import './components/lightbox-delete-item';
import './components/lightbox-checklist-share';
import './components/checklist-quickview';
import './components/section-tabs.js';
import './components/input-date';

$(document).ready(function() {
    //CARD CHECKLIST OPEN
    $('.card-checklist .btn-more-details').on('click', function() {
        $(this).parent('.card-checklist').toggleClass('active');
    })
    //CARD CHECKLIST
    $('.checklist-item input[type="checkbox"]').each(function(){
        if ($(this).is(':checked')){
            $(this).parent().toggleClass('checklist-item--checked');
        }
        $(this).on('change', function(){
            $(this).parent().toggleClass('checklist-item--checked');
        })
    })

    //COPY LINK
    // let generateQuoteBtn = document.querySelector('#generate-quote');
    // let quoteText = document.querySelector('#quote-text');
    // let quoteAuthor = document.querySelector('#quote-author');
    
    // let handleCopyClick = document.querySelector('#copy-quote');
    
    // generateQuoteBtn.addEventListener('click', () => {
    //     fetch('https://api.quotable.io/random')
    //         .then((response) => response.json())
    //         .then((data) => {
    //             quoteText.textContent = data.content;
    //             quoteAuthor.textContent = `- ${data.author}`;
    //         });
    // });
    
    // handleCopyClick.addEventListener('click', () => {
    //     let text = quoteText.textContent;
    //     let author = quoteAuthor.textContent;
    //     navigator.clipboard.writeText(`${text} ${author}`);
    
    //     alert(`Quote by ${author} copied to clipboard!`);
    // });
    


    $('.btn-share-link').on('click', function(e) {
        
        e.preventDefault();
        var copyText = $(this).attr('data-copy');
        navigator.clipboard.writeText(copyText);

        // Alert the copied text
        var link = $(this);
        link.addClass('copied');
        setTimeout(function() {
            link.removeClass('copied');
        }, 1000);
    });

    //CARD CHECKLIST OPEN DETAILS
    $('.product-item .card-options .btn-options').on('click', function() {
        $(this).toggleClass('active');
        $('+ .card-options-menu', this).toggleClass('active');
    });

    $('.product-item .card-options .btn-options').on('mouseup', function() {
        return false;
    });

    $(document).on('mouseup', function(e) {
        if ($(e.target).parent('.product-item .card-options.active').length === 0) {
            $('.product-item .card-options .btn-options').removeClass('active');
            $('.card-options-menu').removeClass('active');
        }
    });

    // CHECKLIST STATUS COUNTER
    $(':checkbox').on('change', function() {

        const currentForm = $(this).parents('form:first');

        // store checkbox state to DB using ajax
        $.ajax({
            type: 'POST',
            url: page_ajax.wp_ajax_file,
            dataType: 'json',
            data: {
                action: 'taskStatus',
                form_details: currentForm.serialize(),
            },
            success: function(data) {
                // $('input:checkbox', currentForm).prop('disabled', false);
                console.log('success');
                // console.table(data);
            },
        });
        
        updateChecklistTasks(currentForm)
        
    })

    function updateChecklistTasks(currentForm){
        // change front-end values
        const postID = $("input[name='checklist-item-id']", currentForm).val();
        const currentStatusPercent = $(`#checklist-status-${postID}`, ).val();
        const numberOfChecked = $('input:checkbox:checked', currentForm).length;
        const totalCheckboxes = $('input:checkbox', currentForm).length;
        const statusPercent = Math.round(numberOfChecked / totalCheckboxes * 100);

        $(`.task--counter-${postID}`).html(`${numberOfChecked}/${totalCheckboxes}`);
        $(`.task--status-${postID}`).html(`${numberOfChecked}/${totalCheckboxes} Task | ${statusPercent} %`);
        $(`.complete--status-${postID}`).css('width', `${statusPercent}%`);
    
        if (currentStatusPercent) {
            // refresh the page if a list is completed
            if (statusPercent == 100){ 
                $('input:checkbox', currentForm).prop('disabled', true);
                location.reload(); 
                // $('input:checkbox', currentForm).prop('disabled', false);
            }

            //refresh the page if the list is removed from completed
            if (currentStatusPercent && currentStatusPercent == 100 && statusPercent < 100){ 
                $('input:checkbox', currentForm).prop('disabled', true);
                location.reload(); 
                // $('input:checkbox', currentForm).prop('disabled', false);
            }
        }
    }

    // SEARCH CHECKLIST
    $(document).on('keyup', '#searchInput', function(e) {
        e.preventDefault()
        $.ajax({
            type: 'POST',
            url: page_ajax.wp_ajax_file,
            dataType: 'html',
            data: {
                action: 'checklistLoadResult',
                search_term: $('#searchInput').val(),
                checklist_type: $('#searchInput').attr('data-checklist-type'),
            },
            success: function(data) {
                $('#searchInput').prop('disabled', false);
                $('#search-result').html(data);
            }
        });
    })

    $(document).on('submit', '#search-form', function(e) {
        e.preventDefault();
        $.ajax({
            type: 'POST',
            url: page_ajax.wp_ajax_file,
            dataType: 'html',
            data: {
                action: 'checklistLoadResult',
                search_term: $('#searchInput').val(),
                checklist_type: $('#searchInput').attr('data-checklist-type'),
            },
            beforeSend: function() {
                $('#searchInput').prop('disabled', true);
            },
            success: function(data) {
                $('#searchInput').prop('disabled', false);
                $('#search-result').html(data);
            }
        });
    })

    // Checklists Likes
    $(document).on('click', '.card-checklist--btn-like', function(e) {
        e.preventDefault()
        var buttonLike = $(this).prop('disabled', true);
        const currentForm = $(this).parents('form:first');

        // if (isUserLoggedIn) {
        //     $(this).toggleClass('active')
        // }

        $(this).toggleClass('active')


        $.ajax({
            type: 'POST',
            url: page_ajax.wp_ajax_file,
            dataType: 'json',
            data: {
                action: 'checkLikes',
                post_id: $("input[name='checklist-item-id']", currentForm).val(),
            },
            success: function(Response) {
                console.log('success');
                // console.table(Response);

                if (Response.like_count >= 1 && isUserLoggedIn === true) {
                    currentForm.find('span').text((Response.like_count > 1) ? `${Response.like_count} Likes` : `${Response.like_count} Like`)
                } 
                else if (Response.like_count < 1 && isUserLoggedIn === true) {
                    currentForm.find('span').text('Like')
                };
            },
            complete: function(){
                buttonLike.prop('disabled', false)
            }
        });
    })

    $(document).on('change','.card-checklist--btn-like', function(){
        if (isUserLoggedIn) {
            $('#lightbox-checklist-quickview .btn-like').toggleClass('active');
        }
    })

})